export const EROUTER = {
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  ACTIVATE_ACCOUNT: "/activate/account",
  HOME: "/",
  WAREHOUSE: "/warehouse",
  ORDER_LIST: "/merchandiser/make-purchage-order",
  RAW_MATERIAL: "/merchandiser/raw-material",
  PACKING_LIST: "/warehouse/packing-list",
};



export enum EORDERHEAD_STATUS {
  SHIPPED = "Shipped",
  CANCELED = "Canceled",
  ALLOCATED = "Allocated",
  PARTLY_SHIPPED = "Partly Shipped",
  PARTLY_ALLOCATED = "Partly Allocated",
  NEW = "New",
  PENDING = "Pending",
}
